<template>
	<div
			:id="advanced.cssId"
			:class="['spacer form_group with_edit_btn', advanced.cssClasses, addedClass, responsiveClasses]"
			:style="outerStyle">
		<div class="aic_juscb_edit" v-if="addedClass === 'single_item'">
			<div class="editable_wrpr">
				<span class="editable_text">{{ this.basic.content }}</span>
			</div>
		</div>
		<div class="inner-spacer" :style="style"></div>
	</div>
</template>

<script>
import {boxShadow, getPadding} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailSpacer',
	props: ['details', 'addedClass'],
	computed: {
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		outerStyle() {
			return {
				margin: getPadding(this.basic.margin),
				padding: getPadding(this.basic.padding),
			}
		},
		style() {
			return {
				borderTopWidth: this.basic.widthNumber ? this.basic.widthNumber.number + 'px' : '1px',
				borderTopColor: this.basic.color ? this.basic.color : '#D5E5FF',
				borderTopStyle: this.basic.style ? this.basic.style : 'solid',
				boxShadow: boxShadow(this.basic.shadows),
			};
		}
	},
}
</script>
